import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  ITrackingObject,
  ITrackingAction,
  ITrackingProperties,
} from 'i2g-ng-tracking';

enum ReadonlyFieldValueType {
  link = 'link',
  text = 'text',
}

@Component({
  selector: 'i2g-readonly-field[value]',
  templateUrl: './readonly-field.component.html',
  styleUrls: ['./readonly-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReadonlyFieldComponent implements OnInit {
  @Input() label: string;
  @Input() value: string;
  @Input() type: ReadonlyFieldValueType;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingAction: ITrackingAction;
  @Input() trackingAdditionalProperties: ITrackingProperties;

  formattedInput: string;

  ngOnInit() {
    if (this.type === ReadonlyFieldValueType.link) {
      this.formattedInput =
        this.value.startsWith('https://') || this.value.startsWith('http://')
          ? this.value
          : `http://${this.value}`;
    } else {
      this.formattedInput = this.value;
    }
  }
}
